import { useFeatureValue } from '@growthbook/growthbook-react'
import { useContext } from 'react'
import { AuthContext } from '../context/authProvider'

export const useTrackConversion = () => {
  const isAffiseEnabled = useFeatureValue('affise_tracking_enabled')
  const { user } = useContext(AuthContext)
  const canTrackConversions = isAffiseEnabled && window?.ASDK
  const userHasClickId = user?.aff_token && user?.token_type?.includes('affise')

  const trackSignup = (clickId) => {
    if (!canTrackConversions || !clickId) return

    window.ASDK?.conversion({
      click_id: clickId,
      goal: 'signup',
      status: '1',
    })
  }

  const trackDepositConversion = (
    depositAmount,
    isFirstTimeDeposit = false,
    currency = 'BRL',
  ) => {
    if (!canTrackConversions || !userHasClickId) return

    const goalType = isFirstTimeDeposit ? 'ftd' : 'deposit'

    window.ASDK?.conversion({
      click_id: user.aff_token,
      goal: goalType,
      status: '1',
      order_currency: currency,
      sum: depositAmount,
    })
  }

  return { trackSignup, trackDepositConversion }
}
